import React, { useMemo } from "react";

import { SupText } from "@repo/core-ui";
import { useStoredData } from "@/store";

interface Web3TxSettingsSlippageProps {
  onClick?: () => void;
}

export default function Web3TxSettingsSlippage({ onClick }: Web3TxSettingsSlippageProps) {
  const storedData = useStoredData();
  const { bridgeSlippage, dexSlippage } = useMemo(() => {
    return storedData.txSettings;
  }, [storedData.txSettings]);
  return (
    <div
      onClick={onClick}
      className="flex h-5 cursor-pointer flex-nowrap items-center justify-between border-0.5 border-neutral-600 duration-100 hover:bg-primary-75
              hover:text-neutral-700 hover:ease-in"
    >
      <div className="flex h-5 items-center space-x-1 border-r-0.5 border-neutral-600 px-1.5">
        <SupText variant="caption" family="mono" className="text-[8px]">
          SLIPPAGE %
        </SupText>
        <SupText variant="caption" family="mono" className="text-[8px]" weight="bold">
          Bridge/Dex
        </SupText>
      </div>
      <span className="px-1.5 font-mono text-[8px] text-neutral-900">
        {bridgeSlippage / 100}/{dexSlippage / 100}
      </span>
    </div>
  );
}
